<template>
	<div>
		<q-table
			ref="table"
			:data="enrollments"
			:columns="columns_awaiting_cancellation"
			row-key="id"
			:pagination.sync="server_pagination"
			@request="requestAwaitingCancellation"
			:loading="loading"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[5, 10, 50, 100]"
			binary-state-sort
			class="q-mt-lg"
		>
			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th v-for="col in props.cols" :key="col.name" :props="props">
					{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<template slot="body" slot-scope="props">
				<q-tr :props="props">
					<q-td key="full_name" :props="props">
						{{ props.row.full_name }}
					</q-td>

					<q-td key="code" :props="props">
						{{ props.row.code }}
					</q-td>

					<q-td key="author" :props="props">
						{{ props.row.author }}
					</q-td>

					<q-td key="created_date" :props="props">
						{{ fDate(props.row.created_date) }}
					</q-td>

					<q-td auto-width key="attachments" :props="props">
						<q-btn
							round
							flat
							icon="fas fa-exclamation"
							color="secondary"
							@click="openEvidence(props.row)"
							:disabled="!props.row.attachments.length"
						>
							<q-tooltip>
								{{ $t('show_evidences') }}
							</q-tooltip>
						</q-btn>
					</q-td>

					<q-td key="actions" :props="props">
						<q-btn
							flat
							round
							color="primary"
							icon="fas fa-clipboard-list"
							@click="
								$router.push({
									name: 'appointment',
									params: { id: props.row.presential_event },
								})
							"
						>
							<q-tooltip>
								{{ $t('training') }}
							</q-tooltip>
						</q-btn>
						<q-btn
							flat
							round
							color="positive"
							icon="fas fa-user-check"
							@click="approveDialog(props.row)"
							:disable="!is_admin"
						>
							<q-tooltip>
								{{ $t('approve') }}
							</q-tooltip>
						</q-btn>

						<q-btn
							flat
							round
							color="negative"
							icon="fas fa-user-times"
							@click="reproveDialog(props.row)"
							:disable="!is_admin"
						>
							<q-tooltip>
								{{ $t('reprove') }}
							</q-tooltip>
						</q-btn>
					</q-td>

					<q-td key="observation" :props="props">
						{{ props.row.observation }}
					</q-td>
				</q-tr>
			</template>
		</q-table>

		<q-dialog v-model="confirm_approve" @ok="approve" prevent-close>
			<span slot="title">{{ $t('approve') }}</span>

			<span slot="message">{{ $t('confirm_approve_cancellation') }}</span>

			<div slot="body">
				<q-input
					type="textarea"
					:placeholder="$t('observation')"
					v-model="confirm_approve_observation"
				/>
			</div>

			<template slot="buttons" slot-scope="props" :props="props">
				<q-btn color="primary" :label="$t('cancel')" @click="closeDialogs()" />
				<q-btn color="positive" :label="$t('approve')" @click="approve()" />
			</template>
		</q-dialog>

		<q-dialog v-model="confirm_reprove" @ok="reprove" prevent-close>
			<span slot="title">{{ $t('remove_item') }}</span>

			<span slot="message">{{ $t('confirm_reprove_cancellation') }}</span>

			<div slot="body">
				<q-input
					type="textarea"
					:placeholder="$t('observation')"
					v-model="confirm_reprove_observation"
				/>
			</div>

			<template slot="buttons" slot-scope="props" :props="props">
				<q-btn color="primary" :label="$t('cancel')" @click="closeDialogs()" />
				<q-btn color="negative" :label="$t('reprove')" @click="reprove()" />
			</template>
		</q-dialog>

		<q-dialog v-model="attachments_view">
			<span slot="title">{{ $t('evidences') }}</span>

			<div slot="body">
				<q-list dense bordered padding separator class="q-mt-md">
					<q-item v-for="(attachment, index) in attachments_to_view" :key="index">
						<q-item-side icon="fas fa-check" color="positive" />
						<q-item-main>
							<a :href="attachment" class="text-black" target="_blank">
								{{ $truncateLink(attachment) }}</a
							>
						</q-item-main>
					</q-item>
				</q-list>
			</div>
		</q-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
	name: 'AdminEnrollmentAwaitingCancellation',

	props: ['load', 'is_admin'],

	data() {
		return {
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: null,
				descending: false,
				sortBy: null,
			},
			attachments_view: false,
			attachments_to_view: null,
			confirm_approve: false,
			confirm_reprove: false,
			confirm_approve_observation: '',
			confirm_reprove_observation: '',
			user_id: null,
			presential_event: null,
			presential_seat_id: null,
			enrollments: [],
			columns_awaiting_cancellation: [
				{
					name: 'full_name',
					required: true,
					label: 'participant',
					align: 'left',
					field: 'full_name',
					sortable: false,
				},
				{
					name: 'code',
					required: true,
					label: 'training_code',
					align: 'left',
					field: 'code',
					sortable: false,
				},
				{
					name: 'author',
					required: true,
					label: 'owner_email',
					align: 'left',
					field: 'author',
					sortable: false,
				},
				{
					name: 'created_date',
					required: true,
					label: 'date',
					align: 'center',
					field: 'created_date',
					sortable: false,
				},
				{
					name: 'attachments',
					required: true,
					label: 'evidences',
					align: 'center',
					field: 'attachments',
					sortable: false,
				},
				{
					name: 'actions',
					required: true,
					label: '',
					align: 'right',
					field: 'actions',
					sortable: false,
				},
				{
					name: 'observation',
					required: true,
					label: 'motive',
					align: 'left',
					field: 'observation',
					sortable: false,
				},
			],
			loading: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			id_user_language_selected: 'common/id_user_language_selected',
			num_rows: 'datatable/num_rows',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},
	},

	methods: {
		requestAwaitingCancellation({ pagination }) {
			this.loading = true
			this.server_pagination = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				ordering: order_by,
				status: 4,
			}

			this.savePagination()

			this.$axios
				.get(
					`/presential_manager/admin_presential_seats/list_cancellation_enrollment/?${this.$qs.stringify(
						data
					)}`,
					this.getHeader
				)
				.then((response) => {
					this.server_pagination.rowsNumber = response.data.count
					this.enrollments = response.data.results
						? response.data.results
								.map((e) => {
									return {
										...e,
										actions: e.presential_event,
										id_log: 1,
									}
								})
								.filter((e) => !e.analyzed)
						: []
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		closeDialogs() {
			this.confirm_approve = false
			this.confirm_reprove = false
			this.confirm_approve_observation = ''
			this.confirm_reprove_observation = ''
			this.user_id = null
			this.presential_event = null
			this.presential_seat_id = null
		},

		approveDialog(data) {
			this.confirm_approve = true
			this.user_id = data.user_id
			this.presential_event = data.presential_event
		},

		reproveDialog(data) {
			this.confirm_reprove = true
			this.user_id = data.user_id
			this.presential_event = data.presential_event
		},

		approve() {
			this.$q.loading.show()
			this.confirm_approve = false

			let fd = new FormData()
			fd.append('user_id', this.user_id)
			fd.append('presential_event', this.presential_event)
			fd.append('observation', this.confirm_approve_observation)

			this.$axios
				.post(
					`/presential_manager/admin_presential_seats/approve_enrollment_cancellation/`,
					fd,
					this.getHeader
				)
				.then((response) => {
					this.presential_seat_id = response.data.presential_event_seat
						? response.data.presential_event_seat
						: null
					this.$q.notify({
						message: this.$t('request_approved'),
						type: 'positive',
						icon: 'far fa-save',
					})
				})
				.catch((e) => {
					console.log(e)
					this.$q.notify({
						message: this.$t('error_approving_request'),
						type: 'negative',
						icon: 'fas fa-ban',
					})
				})
				.finally(() => {
					this.$q.loading.hide()

					this.$emit('change_tab', 'cancellation_approved')

					if (this.presential_seat_id) {
						this.forceRefreshVacancies()
					} else this.closeDialogs()
				})
		},

		reprove() {
			this.$q.loading.show()
			this.confirm_reprove = false

			let fd = new FormData()
			fd.append('user_id', this.user_id)
			fd.append('presential_event', this.presential_event)
			fd.append('observation', this.confirm_reprove_observation)

			this.$axios
				.post(
					`/presential_manager/admin_presential_seats/reprove_enrollment_cancellation/`,
					fd,
					this.getHeader
				)
				.then(() => {
					this.$q.notify({
						message: this.$t('request_reproved'),
						type: 'positive',
						icon: 'far fa-save',
					})
				})
				.catch((e) => {
					console.log(e)
					this.$q.notify({
						message: this.$t('error_reproving_request'),
						type: 'negative',
						icon: 'fas fa-ban',
					})
				})
				.finally(() => {
					this.$q.loading.hide()
					this.closeDialogs()
					this.$emit('change_tab', 'cancellation_reproved')
				})
		},

		forceRefreshVacancies() {
			if (this.presential_event && this.presential_seat_id) {
				this.$axios
					.get(
						`/presential_manager/presential_event_seats/${
							this.presential_event
						}/presential_event_seat/${this.presential_seat_id}/`,
						this.getHeader
					)
					.then(() => {})
					.catch((e) => {
						console.log(e)
					})
					.finally(() => {
						this.closeDialogs()
					})
			}
		},

		fDate(d) {
			if (d) {
				let format = ''

				switch (this.id_user_language_selected) {
					case 1:
					case 3:
						format = 'DD/MM/YYYY HH:mm:ss'
						break
					default:
						format = 'MM-DD-YYYY HH:mm:ss'
						break
				}

				return date.formatDate(d, format)
			}
		},

		savePagination() {
			this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
		},

		loadPagination() {
			this.server_pagination.rowsPerPage = this.num_rows
		},

		openEvidence(el) {
			this.attachments_to_view = el.attachments.map((e) => e)
			this.attachments_view = true
		},
	},

	watch: {
		load: function() {
			if (this.load) {
				this.requestAwaitingCancellation({ pagination: this.server_pagination })
			}
		},

		num_rows: {
			handler: function(newValue) {
				this.loadPagination()
			},
			deep: true,
		},
	},

	mounted() {
		this.loadPagination()
		this.requestAwaitingCancellation({ pagination: this.server_pagination })
	},
}
</script>

<style></style>
